package com.milta.core.localization.translations.bg

import com.milta.core.localization.SettingsStrings

internal val Settings = SettingsStrings(
    profileSectionTitle = "ПРОФИЛ НА ОРГАНИЗАЦИЯТА",
    profileNameLabel = "Име на организацията",
    languageSectionTitle = "ЕЗИК НА ИНТЕРФЕЙСА",
    languageSearchPlaceholder = "Търсене на език...",
    languageMoreAvailable = "%d други налични езика",
    languageErrorGeneric = "Възникна грешка. Моля, опитайте отново.",
    subscriptionSectionTitle = "АБОНАМЕНТ",
    subscriptionPlanLabel = "План",
    subscriptionBillingLabel = "Фактуриране",
    subscriptionRenewalLabel = "Следващо подновяване",
    subscriptionBillingMonthly = "Месечно",
    subscriptionBillingAnnual = "Годишно",
    subscriptionPlanOrganisationLabel = "Организация (Мениджър + екип)",
    subscriptionPriceSuffix = "без ДДС / месец",
    subscriptionUnavailable = "Недостъпно",
    deleteSectionTitle = "Изтриване на организацията",
    deleteWarning = "Това действие е окончателно и необратимо.",
    deleteDescription = "Маршрутите и доказателствата за доставка ще бъдат изтрити. Профилите на шофьорите ще бъдат отделени от организацията, но никога изтрити.",
    deleteConfirmLabel = "За потвърждение въведете името на организацията",
    deleteButton = "Изтрий окончателно",
    deleteFinalDialogTitle = "Потвърждавате ли окончателното изтриване?",
    deleteFinalDialogMessage = "Това действие не може да бъде отменено. Организацията, нейните маршрути и доказателства за доставка ще бъдат изтрити окончателно.",
    deleteErrorGeneric = "Възникна грешка. Моля, опитайте отново.",
    legalSectionTitle = "ПРАВНА ИНФОРМАЦИЯ",
    legalTermsLabel = "Условия за ползване",
    legalPrivacyLabel = "Поверителност и GDPR",
)
